module.exports = __webpack_public_path__ + "img/dodecahedron.9b322fe3.png";